import { useOne } from '@refinedev/core';
import type { PublisherListOut } from '@/api/generated/schemas';
import { ShowIconLink } from '@/components/common/ShowIconLink';

interface PublisherIconLinkProps {
  publisherId: number;
  /** Full publisher record. When provided, no fetch is performed — lists should
   * pass one from a `useMany` batch instead of paying a request per row. */
  publisher?: PublisherListOut;
}

/** Publisher reference display: name with a `LinkOutlined` link to its show
 * page, falling back to the id until the name loads. */
export const PublisherIconLink = ({
  publisherId,
  publisher,
}: PublisherIconLinkProps) => {
  const { result } = useOne<PublisherListOut>({
    resource: 'user_catalog.publishers',
    id: publisherId,
    queryOptions: { enabled: !publisher },
  });

  const record = publisher ?? result;

  return (
    <ShowIconLink resource="user_catalog.publishers" id={publisherId}>
      {record?.name ?? publisherId}
    </ShowIconLink>
  );
};
